"use client";
import React, { useState, KeyboardEvent, ChangeEvent } from "react";
import Icon from "../icons/Icons";

interface FloatingInputFieldProps {
  type?: string;
  value: string | number;
  onChange: (value: string) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  error?: string;
  label: string;
  autoFocus?: boolean;
  loading?: boolean;
  isDisabled?: boolean;
  maxLength?: number;
  mbClass?: boolean;
  showFloatingLabel?: boolean;
}

const FloatingInputField: React.FC<FloatingInputFieldProps> = ({
  type = "text",
  value,
  onChange,
  onKeyDown,
  error,
  label,
  autoFocus = false,
  maxLength,
  loading = false,
  isDisabled = false,
  mbClass = true,
  showFloatingLabel = true,
}) => {
  const [focused, setFocused] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);

  // real input type
  const inputType =
    type === "password" ? (passwordVisible ? "text" : "password") : type;

  return (
    <label className="block relative">
      <input
        type={inputType}
        value={value}
        autoFocus={autoFocus}
        placeholder={showFloatingLabel ? "" : label}
        maxLength={maxLength}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value)
        }
        onKeyDown={onKeyDown}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        disabled={isDisabled}
        className={`block w-full border text-base leading-6 text-left px-4 py-2.5 text-primaryBlack rounded-2lg sm:rounded-xl ${mbClass ? "mb-6" : ""} ${error ? "border-[#ff0000]" : "border-[#d0d5dd] focus:ring-[#686868] focus:ring-1"}
        `}
      />

      {/* Floating Label */}
      {showFloatingLabel && (
        <span
          className={`absolute bg-white left-4 pointer-events-none leading-1 transition ${error ? "text-[#ff0000]" : "text-[#00000080]"} ${focused || value ? "-top-1.5 text-xs px-1" : "top-3.5 text-base"}`}
        >
          {label}
        </span>
      )}

      {/* Password Toggle Button */}
      {type === "password" && (
        <button
          type="button"
          onClick={() => setPasswordVisible(!passwordVisible)}
          className="absolute right-4 top-0 bottom-0 my-auto cursor-pointer"
        >
          {!passwordVisible ? <Icon.openEyeIcon /> : <Icon.closeEyeIcon />}
        </button>
      )}

      {loading && (
        <div className="absolute right-4 top-0 bottom-0 my-auto transform w-5 h-5 border-[3px] border-solid border-transparent border-t-[#0c3e9f] rounded-full animate-spin" />
      )}

      {error && (
        <p className="absolute -bottom-5 left-3 text-xs text-[#ff0000] max-w-[90%] line-clamp-1">
          {error}
        </p>
      )}
    </label>
  );
};

export default FloatingInputField;
